import { DataTableDesignTokens } from '@primeuix/themes/types/datatable';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/datatable/index.ts
const dt = tDeep(componentCommon.datatable);
const dtCs = tDeep(componentColorScheme.datatable);

export const DataTableTelekomDT: DataTableDesignTokens = {
  headerCell: {
    background: dt.header.cell.background,
    padding: `${dt.header.cell.padding.y} ${dt.header.cell.padding.x}`,
    hoverBackground: dt.header.cell.hover.background,
    hoverColor: dt.header.cell.hover.color,
    selectedBackground: dt.header.cell.selected.background,
    selectedColor: dt.header.cell.selected.color,
  },
  bodyCell: {
    padding: `${dt.body.cell.padding.y} ${dt.body.cell.padding.x}`,
  },
  sortIcon: {
    color: dt.sort.icon.color,
    hoverColor: dt.sort.icon.hover.color,
  },
  colorScheme: {
    light: {
      root: {
        borderColor: dtCs.border.color,
      },
      row: {
        stripedBackground: dtCs.row.striped.background,
      },
      bodyCell: {
        selectedBorderColor: dtCs.body.cell.selected.border.color,
      },
    },
  },
  css: `
    .p-datatable {
        border: 1px var(--colours-basic-stroke) solid;
        border-radius: var(--radius-medium);
        overflow: hidden;
    }
  `,
};
